import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'jhi-column-filter-date',
    template: `
        <!-- TODO bootstrap validation. :valid pseudo-classes not working -->
        <!--<form #f='ngForm' class="needs-validation" [ngClass]="{'was-validated': f.touched}">-->
        <form #f='ngForm'>
            <div class="mb-3 row">
                <label for="from" class="col-form-label col-md-3">{{ 'column-filter.from' | translate }}</label>
                <div class="input-group col-md-9">
                    <input class="form-control" placeholder="{{ 'global.date.placeholder' | translate }}"
                           name="from" [(ngModel)]="filter.from"  [minDate]="minDate" [maxDate]="filter.to"
                           ngbDatepicker [autoClose]="true" #from="ngbDatepicker" id="from">
                    <button class="btn btn-outline-secondary calendar" (click)="from.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                </div>
            </div>
            <div class="mb-3 row">
                <label for="to" class="col-form-label col-md-3">{{ 'column-filter.to' | translate }}</label>
                <div class="input-group col-md-9">
                    <input class="form-control" placeholder="{{ 'global.date.placeholder' | translate }}"
                           name="to" [(ngModel)]="filter.to" [minDate]="minimumDate()"
                           ngbDatepicker [autoClose]="true" #to="ngbDatepicker" id="to">
                        <button class="btn btn-outline-secondary calendar" (click)="to.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                </div>
            </div>
            <div class="footer text-center"><br>
                <button type="submit" class="btn btn-primary btn-sm me-1" [disabled]="!f.valid" (click)="apply(f)">{{ 'apply' | translate }}</button>
                <button class="btn btn-secondary btn-sm" (click)="reset(f)">{{ 'reset' | translate }}</button>
            </div>
        </form>
    `
})
export class ColumnFilterDateComponent implements OnInit {
    @Input() filter: any;

    @Output() onApply = new EventEmitter();
    @Output() onReset = new EventEmitter();

    // Allow to select as far back as year 1970
    minDate = { year: 1970, month: 1, day: 1 };

    ngOnInit(): void {
    }

    apply(form) {
        if (!form.valid) {
            return;
        }
        this.onApply.emit();
    }

    reset(form) {
        form.reset();
        this.onReset.emit();
    }

    minimumDate() {
        if (this.filter.from != null) {
            return this.filter.from;
        }
        return this.minDate;
    }
}
